interface BrowserContext {
  userAgent: string;
  browserInfo: {
    name: string;
    version: string;
  };
  osInfo: {
    name: string;
    version: string;
  };
}

export function collectBrowserContext(): BrowserContext {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return {
      userAgent: 'server',
      browserInfo: { name: 'Unknown', version: 'Unknown' },
      osInfo: { name: 'Unknown', version: 'Unknown' },
    };
  }

  const userAgent = navigator.userAgent;
  const browserInfo = parseBrowserInfo(userAgent);
  const osInfo = parseOSInfo(userAgent);

  return {
    userAgent,
    browserInfo,
    osInfo,
  };
}

function parseBrowserInfo(userAgent: string): { name: string; version: string } {
  const browsers = [
    { name: 'Firefox', regex: /Firefox\/(\d+(?:\.\d+)*)/ },
    { name: 'Opera', regex: /(?:Opera|OPR)\/(\d+(?:\.\d+)*)/ },
    { name: 'Edge', regex: /Edg(?:e)?\/(\d+(?:\.\d+)*)/ },
    { name: 'Chrome', regex: /Chrome\/(\d+(?:\.\d+)*)/ },
    { name: 'Safari', regex: /Version\/(\d+(?:\.\d+)*).*Safari/ },
    { name: 'IE', regex: /(?:MSIE |rv:)(\d+(?:\.\d+)*)/ },
  ];

  for (const browser of browsers) {
    const match = userAgent.match(browser.regex);
    if (match) {
      return { name: browser.name, version: match[1] };
    }
  }

  return { name: 'Unknown', version: 'Unknown' };
}

function parseOSInfo(userAgent: string): { name: string; version: string } {
  const osPatterns = [
    { name: 'Windows', regex: /Windows NT (\d+(?:\.\d+)*)/, versionMap: { '10.0': '10/11', '6.3': '8.1', '6.2': '8', '6.1': '7' } },
    { name: 'macOS', regex: /Mac OS X (\d+[._]\d+(?:[._]\d+)*)/ },
    { name: 'iOS', regex: /iPhone OS (\d+[._]\d+(?:[._]\d+)*)/ },
    { name: 'Android', regex: /Android (\d+(?:\.\d+)*)/ },
    { name: 'Linux', regex: /Linux/ },
    { name: 'Chrome OS', regex: /CrOS/ },
  ];

  for (const os of osPatterns) {
    const match = userAgent.match(os.regex);
    if (match) {
      let version = match[1] || 'Unknown';
      version = version.replace(/_/g, '.');

      if ('versionMap' in os && os.versionMap) {
        const mappedVersion = os.versionMap[version as keyof typeof os.versionMap];
        if (mappedVersion) {
          version = mappedVersion;
        }
      }

      return { name: os.name, version };
    }
  }

  return { name: 'Unknown', version: 'Unknown' };
}
